import { motion } from "framer-motion";
import { BatteryCharging, ClipboardCheck, Forklift, HandCoins, Home, ShieldCheck, Truck, Wrench } from "lucide-react";
import { useLang } from "@/lang";

const ICONS = [ClipboardCheck, Wrench, HandCoins, Truck, ShieldCheck, BatteryCharging, Home, Forklift];
const EASE = [0.22, 1, 0.36, 1];

export default function Services() {
  const { t } = useLang();
  const vw = { once: true, amount: 0.2 };

  return (
    <section id="services" data-testid="what-we-do-section" className="bg-cream-2 py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={vw} transition={{ duration: 0.8, ease: EASE }} className="mb-6 flex items-center gap-4">
            <span className="h-px w-12 bg-gold" />
            <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-gold">{t.services.eyebrow}</p>
          </motion.div>
          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={vw} transition={{ duration: 0.8, ease: EASE, delay: 0.1 }} className="font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl">
            {t.services.title}
          </motion.h2>
          <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={vw} transition={{ duration: 0.8, ease: EASE, delay: 0.2 }} className="mt-5 text-base leading-relaxed text-mutedink sm:text-lg">
            {t.services.sub}
          </motion.p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 36 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={vw}
                transition={{ duration: 0.7, ease: EASE, delay: (i % 4) * 0.08 }}
                data-testid={`service-card-${i + 1}`}
                className="group relative overflow-hidden rounded-2xl border border-hairline bg-white p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/60 hover:shadow-[0_24px_50px_rgba(15,27,45,0.12)]"
              >
                <span aria-hidden="true" className="absolute inset-x-0 top-0 h-0.5 origin-left scale-x-0 bg-gold transition-transform duration-500 group-hover:scale-x-100" />
                <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-500 group-hover:bg-navy group-hover:text-gold">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="font-serif text-xl font-semibold leading-snug text-navy">{s.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-mutedink">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
